export interface ValidationRule {
  type: 'required' | 'minLength' | 'maxLength' | 'pattern' | 'email' | 'min' | 'max' | 'custom';
  value?: any;
  message: string;
  validator?: (value: any) => boolean;
}

export interface SelectOption {
  value: any;
  label: string;
}

export interface FormFieldConfig {
  fieldName: string;
  dataType: VarType;  // Usamos VarType aquí
  isVisible: boolean;
  initialValue?: any;
  fieldLabel: string;
  width?: number;
  options?: SelectOption[];
  validations?: ValidationRule[];
  placeholder?: string;
  cssClass?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  service?: any; // Servicio a usar para obtener los datos
  filter?: any; // Filtro opcional para la consulta
  labelField?: string; // Campo a mostrar como etiqueta
  valueField?: string; // Campo a usar como valor (por defecto 'id')
  openDialogComponent?: any;// Campo a usar como valor (por defecto 'id')
}

export enum controlHttp {
  CREATE = 1,
  READ = 2,
  UPDATE = 3,
  DELETE = 4
}

export interface FormListConfig {
  listName: string;
  fields: FormFieldConfig[];
}

export interface ApiResponse {
  data: any;
  lists?: { [key: string]: any[] };
}

export interface FormButton {
  label: string;
  action: string;
  color: string;
  disabled?: boolean;
}

export class VarType {
  static readonly TEXT = new VarType('text');
  static readonly NUMBER = new VarType('number');
  static readonly BOOLEAN = new VarType('boolean');
  static readonly DATE = new VarType('date');
  static readonly EMAIL = new VarType('email');
  static readonly SELECT = new VarType('select');
  static readonly SELECTDINAMIC = new VarType('selectDinamic');
  static readonly TEXTAREA = new VarType('textarea');
  static readonly CHECKBOX = new VarType('checkbox');
  static readonly PASSWORD = new VarType('password');
  static readonly CURRENCY = new VarType('currency');
  static readonly CHIPS = new VarType('chips');
  static readonly RADIO = new VarType('radio');

  private constructor(public readonly value: string) {}

  toString() {
    return this.value;
  }

  equals(other: VarType): boolean {
    return this.value === other.value;
  }
}